/**
 * Лёгкий параллакс для элементов с data-parallax="<скорость>".
 *
 * Элемент сдвигается по вертикали относительно центра вьюпорта:
 * смещение = (центр вьюпорта − центр элемента) * скорость.
 * Скорость 0.05–0.1 — заметно, но не «уплывает» за пределы блока.
 *
 * Ниже планшета отключён: там карточки идут обычным списком,
 * и сдвиг только мешает.
 */
itsoftApp.createModule("parallax", ["windowScroll", "windowResize"], function () {
    const module = this;

    const Parallax = function () {
        this.items = document.querySelectorAll("[data-parallax]");

        if (!this.items.length) {
            return;
        }

        this.enabled = false;
        this.frame = null;

        this.init();
    };

    Parallax.prototype.checkEnabled = function () {
        /* Тот же брейкпойнт, что и у макета: параллакс только на десктопе */
        this.enabled = window.innerWidth > 1023;

        if (!this.enabled) {
            this.reset();
        }
    };

    Parallax.prototype.reset = function () {
        Array.prototype.forEach.call(this.items, function (item) {
            item.style.transform = "";
        });
    };

    Parallax.prototype.update = function () {
        if (!this.enabled) {
            return;
        }

        const viewportCenter = window.innerHeight / 2;

        Array.prototype.forEach.call(this.items, function (item) {
            const rect = item.getBoundingClientRect();

            if (rect.bottom < 0 || rect.top > window.innerHeight) {
                return;
            }

            const speed = parseFloat(item.getAttribute("data-parallax")) || 0;
            const shift = (viewportCenter - (rect.top + rect.height / 2)) * speed;

            item.style.transform = "translate3d(0, " + shift.toFixed(2) + "px, 0)";
        });
    };

    /*
     * Прошлый кадр отменяем, а не держим флаг «уже запрошено»: если первый
     * requestAnimationFrame не отрисовался (фоновая вкладка, headless без
     * композитора), флаг залипал и параллакс молчал навсегда.
     * Исправление из cartilox-medznat.
     */
    Parallax.prototype.request = function () {
        const self = this;

        if (this.frame !== null) {
            window.cancelAnimationFrame(this.frame);
        }

        this.frame = window.requestAnimationFrame(function () {
            self.frame = null;
            self.update();
        });
    };

    Parallax.prototype.init = function () {
        const self = this;

        this.checkEnabled();
        this.request();

        itsoftApp.modules.windowScroll.addEvent(function () {
            self.request();
        });

        itsoftApp.modules.windowResize.addEvent(function () {
            self.checkEnabled();
            self.request();
        });
    };

    new Parallax();

    module.callback = Parallax;
});
